/* Threads on Design - moved here from snippets/tod-glyph-urls.liquid on 18 OCT 2026 (TEST 6) so phones keep it between pages.
   Edit it here; the notes stay in that file.

   26 OCT 2026 (TEST 9) - every link below is new, and there are now two lists.
   TOD_GLYPHS is each alphabet's base file, as before. TOD_GLYPH_SIZES is one
   file per size the machine actually has letters for: the Order Desk builds a
   51 mm line from the pack's own 51 mm letters, which are drawn and spaced
   differently from the 25 mm ones this page used to enlarge, so the page now
   reads the same file the machine will. Spacing was also re-measured (first
   contact, closed form) in the same rebuild, which is why the base files moved.
   TOD_HIDE_FONTS keeps Bubble Grove off the page: at 38 mm it does not fit the
   apron, and it is held back in make_order.py for the same reason.
   TOD_FONTS_URL is set here as well as in the snippet, pointing at the
   fonts.json from the same rebuild, so the two can never be from different days.
   That fonts.json has the "grand" (51 mm) height taken back out of its height
   list: the shop page adds Grand itself, and tod-bundle.js refuses a manifest
   whose height list is not exactly three long, which would have quietly put
   the page back on its built-in alphabets and threads. */
(function(){
  var B = "https://cdn.shopify.com/s/files/1/0977/1148/9394/files/";
  /* the newest upload of each base (25 mm) file - Shopify put a suffix on these because the old ones share the name */
  var BASE = {
   "great-vibes": "11ac6e53-ecd7-4e7e-84a1-5daf053a5923",
   "samantha": "ea6f520b-3d58-4618-8d16-019c4a8cce1f",
   "kameron": "f0d2d46a-fc59-4a6a-b9f7-29d0766fcf89",
   "anderson": "1bf12366-e212-4c41-99d0-0c37780e981c",
   "emerson": "84f793bf-8a2e-4a77-8c88-2413180b73f4",
   "twilight-mint": "a3eb9500-aaa0-42de-85e8-4933009c3e6b",
   "twilight-crumbs": "3ef27489-cf99-4f23-bd07-08960bc5a59b",
   "golden-butter": "401039d5-cc33-4eb6-8008-19318e89ae30",
   "murphy": "0513e06c-0c58-4c2e-8b75-213d6a3ece6c",
   "william": "d5a30285-817b-4aa1-89c4-cabdef0f3441",
   "alexander": "104311b6-1838-4ac1-9541-82bd76985d54",
   "jessana": "b8b15370-72a2-493e-b8b9-630801f07adb",
   "zarinah": "a99f620f-6817-4266-a770-0a6dfd97c996",
   "elephant": "9990c89e-f1dc-4464-82f9-eb6467442900",
   "college": "22bd0b92-5a80-47e7-bfc6-57538e08108d",
   "snuggle-bear": "0f907b11-a441-4476-9ba1-8ec2a1a76348",
   "puddle-jump": "e0d02e11-bfa0-4b30-ae5d-8131419dc2b9",
   "happy-tangle": "ad689ee3-bb6f-40e5-bc80-f74ba47dceae",
   "noddle-sketch": "8d7c774e-7833-4ef8-a1f9-566aebfc4d40",
   "plain-block": "bf1fd62b-cb24-43be-a788-504aa4778bab",
   "plain-narrow": "86c8139d-7440-4c9f-a464-ebb3c15dc54b",
   "modern-sans": "c56ad674-e17f-40ea-916d-707f983c8439",
   "casual-print": "e4f1f8d4-2610-4cfc-9198-89640f482134",
   "old-style": "df84b5ee-fe51-4d5c-be82-aba73af80bac",
   "book-serif": "8db61497-9007-40e4-b5fe-47795d90006f",
   "classic-serif": "cf475305-e31f-4566-914c-af3c5e068921",
   "old-english": "4a6606af-4dda-4283-880c-a0e3cfa97b0e",
   "old-english-2": "d8216073-c815-4cc5-8d69-9609ba3bde44",
   "barber": "02807484-8f26-4286-af27-94669e410967"
  };
  /* the other sizes each pack has letters for; these names were new, so they kept them */
  var SIZES = {"great-vibes":[20,32,38,44,51],"samantha":[38,51],"kameron":[38,51],"anderson":[38,51],"emerson":[38,51],"twilight-mint":[13,19,38,50,63],"twilight-crumbs":[13,19,38,50,63],"golden-butter":[13,19,38,50,63],"murphy":[38,51],"william":[38,51],"alexander":[38,51],"jessana":[38,51],"zarinah":[13,38,51],"elephant":[38,51],"college":[6,13,19,32,38,44,51],"snuggle-bear":[13,19,38,50,63],"puddle-jump":[13,19,38,50,63],"happy-tangle":[13,19,38,50,63],"noddle-sketch":[13,19,38,50,63],"plain-block":[6,13,19,32,38,44,51],"plain-narrow":[6,13,19,32,38,44,51],"modern-sans":[38,51],"casual-print":[6,13,19,32,38,44,51],"old-style":[6,13,19,32,38,44,51],"book-serif":[38,51],"classic-serif":[6,13,38,51],"old-english":[38,51],"old-english-2":[38,51],"barber":[13,38,51]};
  window.TOD_FONTS_URL = B + "fonts_95472260-7e4f-487a-8b5e-51cef621e029.json";
  window.TOD_HIDE_FONTS = {"bubble-grove": 1};
  var g = {}, s = {};
  Object.keys(BASE).forEach(function(id){
    g[id] = B + "tod-glyphs-" + id + "_" + BASE[id] + ".json";
    s[id] = {"25": g[id]};
    SIZES[id].forEach(function(mm){ s[id][mm] = B + "tod-glyphs-" + id + "-" + mm + "mm.json"; });
  });
  /* Bubble Grove is off the page, but a cart or proof already holding it still
     needs its letters to redraw what was bought - so its old file stays listed */
  g["bubble-grove"] = B + "tod-glyphs-bubble-grove_e60326d9-4ef5-4057-b423-2618ba04f49e.json?v=1788904664";
  window.TOD_GLYPHS = g;
  window.TOD_GLYPH_SIZES = s;
})();
